"use client";

import MoneyAmount from "@/shared/ui/components/money-amount";
import { BlackWalletIcon } from "@/shared/ui/icons/black-wallet-icon";
import { useTranslation } from "react-i18next";

type WalletBoxNewProps = {
  walletBalance: {
    amount: number;
    currency: string;
  };
  isSelected?: boolean;
  onToggle?: (selected: boolean) => void;
  className?: string;
  disabled?: boolean;
};

/** Wallet box for new payment method flow only (Figma design, RTL-aware). */
export function WalletBoxNew({
  walletBalance,
  isSelected = false,
  onToggle,
  className = "",
  disabled = false,
}: WalletBoxNewProps) {
  const { t, i18n } = useTranslation();

  const handleToggle = () => {
    if (!disabled && onToggle) {
      onToggle(!isSelected);
    }
  };

  return (
    <div
      className={`flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
      data-testid="wallet-box"
    >
      <div className="flex min-h-[48px] flex-1 min-w-0 items-center gap-3">
        <div className="flex shrink-0 items-center justify-center rounded-lg bg-[#F5F3FF] p-2 text-[#9600F1]">
          <BlackWalletIcon />
        </div>
        <p className="text-sm font-medium leading-[22.4px] tracking-[-0.21px] text-gray-900">
          {t("payment_confirmation.use_wallet_amount_prefix")}{" "}
          <MoneyAmount
            amount={walletBalance.amount}
            currency={walletBalance.currency}
            language={i18n.language}
            className="inline-flex font-medium text-[#9600F1]"
          />{" "}
          {t("payment_confirmation.use_wallet_amount_suffix")}
        </p>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={isSelected}
        disabled={disabled}
        data-testid="wallet-toggle-switch"
        onClick={(e) => {
          e.stopPropagation();
          handleToggle();
        }}
        className="relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9600F1] focus-visible:ring-offset-2 disabled:cursor-not-allowed"
        style={{
          backgroundColor: isSelected ? "#9600F1" : "#D1D5DB",
        }}
      >
        <span
          className="inline-block h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200"
          style={{
            transform:
              i18n.dir() === "rtl"
                ? isSelected
                  ? "translateX(-22px)"
                  : "translateX(-2px)"
                : isSelected
                  ? "translateX(22px)"
                  : "translateX(2px)",
          }}
        />
      </button>
    </div>
  );
}

